var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { TextField as MuiTextField } from "@mui/material";
import { TextUpdateMode } from "../../../../types/forms";
var MultipleTextItemInput = function (_a) {
    var item = _a.item, value = _a.value, isEnabled = _a.isEnabled, textUpdateMode = _a.textUpdateMode, maxLength = _a.maxLength, onCommit = _a.onCommit;
    var _b = useState(value), localValue = _b[0], setLocalValue = _b[1];
    useEffect(function () {
        setLocalValue(value);
    }, [value]);
    var isOnTyping = textUpdateMode === TextUpdateMode.ON_TYPING;
    var displayValue = isOnTyping ? value : localValue;
    var handleChange = function (e) {
        var newValue = e.target.value;
        if (isOnTyping) {
            onCommit(item.name, newValue);
            return;
        }
        setLocalValue(newValue);
    };
    var commit = function () {
        if (isOnTyping) {
            return;
        }
        if (localValue === value) {
            return;
        }
        onCommit(item.name, localValue);
    };
    var handleBlur = function () {
        commit();
    };
    var handleKeyDown = function (e) {
        if (e.key === "Enter") {
            commit();
        }
    };
    return (_jsx(MuiTextField, { fullWidth: true, label: item.title || item.name, value: displayValue, onChange: handleChange, onBlur: handleBlur, onKeyDown: handleKeyDown, placeholder: item.placeholder, disabled: !isEnabled, helperText: maxLength ? (_jsxs("span", __assign({ style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
            } }, { children: [_jsx("span", { style: { width: "100%" } }), _jsx("span", { children: "".concat(displayValue.length, "/").concat(maxLength) })] }))) : null, inputProps: {
            maxLength: maxLength,
        } }));
};
export default MultipleTextItemInput;
